import React, { useState, useEffect } from 'react';
import {
    Box,
    ClickAwayListener,
    IconButton,
    InputAdornment,
    Paper,
    TextField
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChevronDownIcon, ChevronUpIcon } from '../../icons';

const useStyles = makeStyles({
    dropDown: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        right: '-15px',
        top: '100%',
        padding: '5px 0',
        minWidth: '50px',
        zIndex: 10
    },
    dropDownElem: {
        padding: '5px 10px',
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.05)',
            cursor: 'pointer'
        }
    }
});

function strToNumberKind(value) {
    if (value && value[0] === '-') {
        // Set pricerule to disabled
        return -1;
    }
    const parsed = parseFloat(`${value}`.replace(/-\D/g, ''));
    return Number.isNaN(parsed) ? '' : parsed;
}

const FloatTextbox = props => {
    const classes = useStyles();

    const {
        value,
        setValue,
        setPostfix,
        variant = 'outlined',
        options = [],
        // default to first element from options
        postfix = options[0] || '',
        label,
        ...otherProps
    } = props;
    const [dropdownVisible, setDropdownVisible] = useState(false);

    useEffect(() => {
        if (options.length === 0 || setPostfix === undefined) {
            return;
        }
        setPostfix(postfix);
    }, []);

    const endAdornment = (
        <>
            {options.length > 0 && (
                <InputAdornment position="end">
                    {postfix}
                    <IconButton
                        aria-label="toggle dropdown"
                        onClick={() => setDropdownVisible(!dropdownVisible)}
                    >
                        {dropdownVisible ? <ChevronUpIcon /> : <ChevronDownIcon />}
                    </IconButton>
                    {dropdownVisible && (
                        <ClickAwayListener onClickAway={() => setDropdownVisible(false)}>
                            <Paper className={classes.dropDown}>
                                {options.map(item => {
                                    return (
                                        <Box
                                            key={`${item}`}
                                            className={classes.dropDownElem}
                                            onClick={() => {
                                                setPostfix(item);
                                                setDropdownVisible(!dropdownVisible);
                                            }}
                                        >
                                            {item}
                                        </Box>
                                    );
                                })}
                            </Paper>
                        </ClickAwayListener>
                    )}
                </InputAdornment>
            )}
        </>
    );

    return (
        <TextField
            {...otherProps}
            variant={variant}
            value={strToNumberKind(value)}
            onChange={event => {
                setValue(strToNumberKind(event.target.value));
            }}
            label={label}
            InputProps={{
                endAdornment
            }}
        />
    );
};

export default FloatTextbox;
